export type ManageArea = 'site' | 'design' | 'code' | 'health';

export const MANAGE_AREAS: Array<[ManageArea, string]> = [
  ['site', 'Site'],
  ['design', 'Design'],
  ['code', 'Code & tracking'],
  ['health', 'Site health'],
];

export const isManageArea = (v: unknown): v is ManageArea => MANAGE_AREAS.some(([k]) => k === v);

/** Where a Manage area lives; `hash` scrolls to one section of it. */
export const manageUrl = (area: ManageArea = 'site', hash?: string) =>
  `/content?view=manage&area=${area}${hash ? `#${hash}` : ''}`;

export const ARTICLE_SETTINGS_PATH = '/content/settings';
export const FORM_SETTINGS_PATH = '/content/forms/settings';

/**
 * Areas Manage had until backlog 46b884ba, for old links: per-type settings moved
 * to a Settings button on their tab. Overview and Pages had nothing of their own.
 */
const MOVED_AREAS: Record<string, string> = {
  overview: manageUrl('site'),
  pages: '/content?view=pages',
  articles: ARTICLE_SETTINGS_PATH,
  media: '/content?view=media',
  forms: FORM_SETTINGS_PATH,
};

export const movedManageArea = (area: string | null, hash = '') =>
  area && MOVED_AREAS[area] ? `${MOVED_AREAS[area]}${hash}` : null;
